export class SecretData {
  sellerDescriptionValue: string;
  merchantCodeGroupValue: string;
  publicKeyValue: string;
  privateKeyValue: string;
  splitTrx: boolean;
}
